interface Feature {
  title: string;
  description: string;
  icon: string;
}

interface Features7Props {
  sectionId?: string;
  title?: string;
  description?: string;
  features?: Feature[];
}

export const Features7 = ({
  // sectionId = 'The Complete Solutions',
  title = 'The Complete Solutions',
  description = 'Ligula risus auctor tempus magna feugiat lacinia.',
  features = [
    {
      title: 'Integrated',
      description: 'Feugiat primis ipsum and ultrice a semper lacus',
      icon: 'flaticon-layers-1'
    },
    {
      title: 'Intuitive',
      description: 'Feugiat primis ipsum and ultrice a semper lacus',
      icon: 'flaticon-click-1'
    },
    {
      title: 'Flexible',
      description: 'Feugiat primis ipsum and ultrice a semper lacus',
      icon: 'flaticon-prioritize'
    },
    {
      title: 'Efficient',
      description: 'Feugiat primis ipsum and ultrice a semper lacus',
      icon: 'flaticon-analytics'
    }
  ]
}: Features7Props) => {
  return (
    <section
      id="features-7"
      className="pt--100 pt-[100px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] features-section division"
    >
      <div className="container">
        {/* SECTION TITLE */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center">
          <div className="md:w-10/12 lg:max-xl:w-9/12 xl:w-9/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="section-title mb--70 xl:!mb-[70px] lg:max-xl:!mb-[60px] md:max-lg:!mb-[50px] !text-center">
              {/* Title */}
              <h2 className="s-50 w--700 xl:!text-[3.125rem] lg:max-xl:!text-[2.875rem] md:max-lg:!text-[2.64705rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !font-bold !tracking-[-0.5px] leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                {title}
              </h2>
              {/* Text */}
              <p className="s-21 color--grey xl:!text-[1.3125rem] xl:!mt-[18px] !mb-0 lg:max-xl:!mt-[15px] lg:max-xl:!text-[1.18755rem] md:max-lg:!text-[1.32352rem] md:max-lg:!mt-[12px] sm:max-md:!text-[1.21875rem] sm:max-md:!mt-[12px] xsm:max-sm:!text-[1.1875rem] xsm:max-sm:!mt-[12px] xsm:max-sm:px-[3%] xsm:max-sm:py-0">
                {description}
              </p>
            </div>
          </div>
        </div>
        {/* FEATURES-7 WRAPPER */}
        <div className="fbox-wrapper !text-center">
          <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] row-cols-1 row-cols-md-2 row-cols-lg-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className="col md:max-lg:w-6/12 lg:max-xl:w-3/12 xl:w-3/12 flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)]"
              >
                <div className="fbox-7 fb-1 p-[35px_20px_30px] lg:max-xl:pt-[28px] lg:max-xl:!pb-[25px] lg:max-xl:px-[15px] sm:max-md:pt-[45px] sm:max-md:!pb-[40px] sm:max-md:!px-[50px] xsm:max-sm:pt-[40px] xsm:max-sm:!pb-[35px] xsm:max-sm:px-[55px] [border:2px_solid_#eee] rounded-[12px] wow fadeInUp">
                  {/* Icon */}
                  <div className="fbox-ico ico-50 !mb-[20px] xsm:max-sm:!mb-[20px]">
                    <div className="shape-ico color--theme relative inline-block !m-[0_auto]">
                      {/* Vector Icon */}
                      <span className={`${feature.icon} relative z-[2]`}></span>
                      {/* Shape */}
                      <svg
                        className="xl:!w-[130px] xl:!h-[130px] top-[-35px] left-[calc(50%_-_60px)] lg:max-xl:!w-[110px] lg:max-xl:!h-[110px] lg:max-xl:top-[-30px] lg:max-xl:left-[calc(50%_-_55px)] md:max-lg:!w-[95px] md:max-lg:!h-[95px] md:max-lg:top-[-25px] md:max-lg:left-[calc(50%_-_50px)] sm:max-md:!w-[125px] sm:max-md:!h-[125px] sm:max-md:top-[-35px] sm:max-md:left-[calc(50%_-_65px)] xsm:max-sm:!w-[120px] xsm:max-sm:!h-[120px] xsm:max-sm:top-[-35px] xsm:max-sm:left-[calc(50%_-_60px)] !absolute z-[1]"
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M69.8,-23C76.3,-2.7,57.6,25.4,32.9,42.8C8.1,60.3,-22.7,67,-39.1,54.8C-55.5,42.7,-57.5,11.7,-48.6,-11.9C-39.7,-35.5,-19.8,-51.7,5.9,-53.6C31.7,-55.6,63.3,-43.2,69.8,-23Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  {/* End Icon */}
                  {/* Text */}
                  <div className="fbox-txt">
                    <h6 className="s-20 w--700 xl:!text-[1.25rem] lg:max-xl:!text-[1.18755rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[10px] lg:max-xl:!mb-[12px] md:max-lg:!mb-[12px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                      {feature.title}
                    </h6>
                    <p className="p-sm !mb-0">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* End row */}
        </div>
        {/* END FEATURES-7 WRAPPER */}
      </div>
      {/* End container */}
    </section>
  );
};
